export const GRAPH_VIEW = 'graphView'
export const DATE_FIRST = 'dateFirst'
export const DATE_SECOND = 'dateSecond'
export const DEMONSTRATION = 'demonstration'
export const DATE_FORMAT = 'dd.MM.yyyy'
export const FAST_INTERVAL = 'fastInterval'
export const TYPE = 'type'
export const INTEGRATION_TYPES = 'integrationTypes'
